export abstract class SharedPageTitleService {
  abstract setPageTitle(contentTitle: string): void;
}
